import { CalendarEventDisplayData } from "../components/calendar_page";

export function getEventId(event: CalendarEventDisplayData) {
	return "message_id" in event ? event.message_id : event.id;
}
